webpackJsonp([1],{

/***/ "+nIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.inspiration",modifiers:{"inspiration":true}}],staticClass:"color-blue",attrs:{"size":"sm","variant":"link"}},[_c('span',[_vm._v("Inspire Me")]),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil fa-lg animated jello",attrs:{"id":"pencil","aria-hidden":"true"}})]),_vm._v(" "),_c('b-modal',{ref:"inspiration",attrs:{"id":"inspiration","size":"lg","hide-header":"","hide-footer":""}},[_c('inspiration',{staticClass:"mt-4",attrs:{"type":_vm.type,"selected":_vm.selected}}),_vm._v(" "),_c('button',{ref:"modalClose",staticClass:"btn modal-close",attrs:{"type":"button"},on:{"click":_vm.close}},[_c('i',{staticClass:"fa fa-times fa-lg",attrs:{"aria-hidden":"true"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "10El":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login')?_c('navigation'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"main-anim"}},[_c('router-view',{staticClass:"mb-5"})],1),_vm._v(" "),(_vm.$route.name !== 'login')?_c('bottom-footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "181b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_footer_vue__ = __webpack_require__("YOML");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a07f468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_bottom_footer_html__ = __webpack_require__("Iu8n");
function injectStyle (ssrContext) {
  __webpack_require__("nAE/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a07f468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottom_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a07f468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_bottom_footer_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3UWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_basket_js__ = __webpack_require__("VFgK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705dd258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basket_vue__ = __webpack_require__("dYah");
function injectStyle (ssrContext) {
  __webpack_require__("YgiE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-705dd258"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_basket_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705dd258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "584s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_artwork_requirements_vue__ = __webpack_require__("lN9d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03e417e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_artwork_requirements_vue__ = __webpack_require__("ROGF");
function injectStyle (ssrContext) {
  __webpack_require__("y+/s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d03e417e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_artwork_requirements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03e417e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_artwork_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5nkz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/navavatar.1cf3480.png";

/***/ }),

/***/ "68I3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pom-dashboard"}},[_c('div',{staticClass:"container-fluid no-gutters"},[_c('div',{staticClass:"row justify-content-center hero-image overlay",style:(_vm.heroImageOverride)},[_c('div',{staticClass:"col-md-7 col-sm-12"},[_c('div',{staticClass:"hero-text"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.heading)}}),_vm._v(" "),_c('p',{staticClass:"text-dark"},[_vm._v("Dear Guild Member, ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-dark"},[_vm._v("Alternatively, please visit our new Digital Hub for Direct Mail campaigns, Window Cards and Canvassing Card orders up to 500 units. The Digital Hub can be accessed via the main menu in the Members Hub.")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-dark"},[_vm._v("Please note that due to pricing fluctuations resulting from lockdown, our POM pricing is no longer fully accurate. We are in the process of renegotiating our print prices but in the meantime we are still operating as usual at very competitive rates so please email "),_c('a',[_vm._v("customersuccess@guildproperty.co.uk")]),_vm._v(" for a quote. Please include as much information as possible in regards to the product that you would like and reference to whether you would like to distribute your product via Royal Mail Door to Door.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7nwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navigation",
  data: function data() {
    return {
      products: [],
      system: [],
      user: [],
      productSearchTerm: "",
      searchResults: []
    };
  },

  methods: {
    searchProduct: function searchProduct() {
      this.searchResults = [];
      // regex products against search term and display list
      if (this.productSearchTerm != "") {
        for (var i = 0; i < this.products.length; i++) {
          if (this.products[i].name.toLowerCase().indexOf(this.productSearchTerm.toLowerCase()) !== -1) {
            this.searchResults.push(this.products[i]);
          }
        }
      }
    },
    clearSearch: function clearSearch(event) {
      if (event.relatedTarget != null) {
        if (event.relatedTarget.className != null) {
          if (event.relatedTarget.className != "agentColour2TextHover") {
            this.searchResults = [];
          }
        }
      } else {
        this.searchResults = [];
      }
    },
    fetch: function fetch() {
      var _this = this;

      // fetch the products
      this.axios.get("/api/product").then(function (response) {
        _this.products = response.data;
        _this.selectedProduct = _this.products[0].id;
      }).catch(function (error) {
        console.log(error);
      });
      // fetch the system info
      this.axios.get("/api/system").then(function (response) {
        _this.system = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      // fetch the user
      this.axios.get("/api/user").then(function (response) {
        _this.user = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    logout: function logout() {
      var _this2 = this;

      this.axios.post('/api/user/logout').then(function (response) {
        _this2.$router.push('/login');
      }).catch(function (error) {
        _this2.$router.push('/login');
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),

/***/ "7qkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'cannot-find-button'
});

/***/ }),

/***/ "7s5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_new_js__ = __webpack_require__("8XzR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e62f7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_new_vue__ = __webpack_require__("lPBv");
function injectStyle (ssrContext) {
  __webpack_require__("JTfW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60e62f7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_new_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e62f7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Bi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_finder_vue__ = __webpack_require__("jfHl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f8930c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_finder_vue__ = __webpack_require__("qr4Y");
function injectStyle (ssrContext) {
  __webpack_require__("bi2A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25f8930c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_finder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f8930c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_finder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8XzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__("8o1w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_cannot_find_button_cannot_find_button__ = __webpack_require__("zxIB");




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'order-page',
    components: { CannotFindButton: __WEBPACK_IMPORTED_MODULE_1__modules_cannot_find_button_cannot_find_button__["a" /* default */] },
    props: ['productId', 'orderId'],
    data: function data() {
        return {
            loading: 0,
            product: null,
            order: null,
            orderError: null,
            availableSpecification: { documentSize: [], extent: [], orientation: [], stockWeight: [], lamination: [] },
            specification: { documentSize: null, extent: null, orientation: null, stockWeight: null, lamination: null },
            specificationId: 0,
            quantity: 0,
            // artwork: false,
            artwork: 0,
            chosenArtwork: null,
            invalidQuantity: false,
            resettingQuantity: false,
            popSpecification: null,
            price: 0,
            design: { spec: 0, item: 0, price: 35, loading: false },
            carriage: { spec: 0, item: 0, price: 6, loading: false },
            carouselIndex: 0,
            priceTable: [{ quantity: 1, price: 0, loading: false }, { quantity: 2, price: 0, loading: false }, { quantity: 5, price: 0, loading: false }, { quantity: 10, price: 0, loading: false }, { quantity: 20, price: 0, loading: false }, { quantity: 50, price: 0, loading: false }, { quantity: 100, price: 0, loading: false }, { quantity: 200, price: 0, loading: false }, { quantity: 500, price: 0, loading: false }, { quantity: 1000, price: 0, loading: false }, { quantity: 2000, price: 0, loading: false }, { quantity: 5000, price: 0, loading: false }, { quantity: 10000, price: 0, loading: false }, { quantity: 20000, price: 0, loading: false }, { quantity: 50000, price: 0, loading: false }, { quantity: 100000, price: 0, loading: false }, { quantity: 200000, price: 0, loading: false }, { quantity: 500000, price: 0, loading: false }, { quantity: 1000000, price: 0, loading: false }]
        };
    },

    computed: {
        canOrder: function canOrder() {
            return this.artwork != 2 || this.chosenArtwork ? this.loading <= 0 && this.price > 0 : false;
        },
        finalPrice: function finalPrice() {
            return this.calculatedPrice(this.price, this.quantity);
        },
        images: function images() {
            return this.product ? JSON.parse(this.product.images) : [];
        }
    },
    methods: {
        fetchProduct: function fetchProduct() {
            var _this = this;

            this.loading++;
            this.resetProduct();
            __WEBPACK_IMPORTED_MODULE_0__http_common__["b" /* POM */].get('product/' + this.productId).then(function (response) {
                _this.loading--;
                _this.product = response.data;
                _this.fetchSpecificationOptions('documentSize', true);
                if (_this.orderId) {
                    _this.fetchOrder();
                } else {
                    _this.loadProductSpecification();
                }
            }).catch(function (error) {
                _this.loading--;
            });
        },
        fetchOrder: function fetchOrder() {
            var _this2 = this;

            if (!this.orderId) {
                return;
            }
            this.loading++;
            __WEBPACK_IMPORTED_MODULE_0__http_common__["b" /* POM */].get('basket/order/' + this.orderId).then(function (response) {
                _this2.loading--;
                _this2.order = response.data;
                _this2.chosenArtwork = { image: _this2.order.specification.design };
                _this2.loadProductSpecification();
            }).catch(function (error) {
                _this2.loading--;
            });
        },
        loadProductSpecification: function loadProductSpecification() {
            if (this.order) {
                this.specification = this.order.specification;
                this.quantity = this.order.quantity;
                this.artwork = this.order.specification.artwork;
            } else if (this.product.alias == 'Brochure') {
                this.specification = { documentSize: 'A4', extent: 12, orientation: 'Portrait', stockWeight: 170, lamination: 'None' };
                this.quantity = 500;
            } else if (this.product.alias == 'Folders') {
                this.specification = { documentSize: '300x215x5', extent: 4, orientation: 'Portrait', stockWeight: 350, lamination: 'Matt' };
                this.quantity = 500;
            } else if (this.product.alias == 'Canvassing') {
                this.specification = { documentSize: 'A5', extent: 2, orientation: 'Landscape', stockWeight: 300, lamination: 'None' };
                this.quantity = 5000;
            } else if (this.product.alias == 'Minimags') {
                this.specification = { documentSize: 'A5', extent: 4, orientation: 'Landscape', stockWeight: 150, lamination: 'None' };
                this.quantity = 5000;
            } else if (this.product.alias == 'Leaflets & Folded Cards') {
                this.specification = { documentSize: 'A4', extent: 2, orientation: 'Portrait', stockWeight: 170, lamination: 'None' };
                this.quantity = 250;
            }
        },
        fetchSpecificationOptions: function fetchSpecificationOptions(option) {
            var _this3 = this;

            var fetchNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var params = {
                description: this.product.alias,
                output: option
            };
            var nextOption = null;
            if (option == 'documentSize') {
                nextOption = 'extent';
            } else if (option == 'extent') {
                nextOption = 'orientation';
                params['documentSize'] = this.specification.documentSize;
            } else if (option == 'orientation') {
                nextOption = 'stockWeight';
                params['documentSize'] = this.specification.documentSize;
                params['extent'] = this.specification.extent;
            } else if (option == 'stockWeight') {
                nextOption = 'lamination';
                params['documentSize'] = this.specification.documentSize;
                params['extent'] = this.specification.extent;
                params['orientation'] = this.specification.orientation;
            } else if (option == 'lamination') {
                params['documentSize'] = this.specification.documentSize;
                params['extent'] = this.specification.extent;
                params['orientation'] = this.specification.orientation;
                params['stockWeight'] = this.specification.stockWeight;
            }
            this.loading++;
            __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('specification', { params: params }).then(function (response) {
                _this3.loading--;
                _this3.$set(_this3.availableSpecification, option, response.data.results);
                if (response.data.results.length == 1) {
                    _this3.$set(_this3.specification, option, response.data.results[0]);
                }
                if (fetchNext && nextOption) {
                    _this3.fetchSpecificationOptions(nextOption, fetchNext);
                }
            }).catch(function (error) {
                _this3.loading--;
            });
        },
        fetchPopSpecification: function fetchPopSpecification(callback) {
            var _this4 = this;

            var params = {
                description: this.product.alias,
                documentSize: this.specification.documentSize,
                extent: this.specification.extent,
                orientation: this.specification.orientation,
                stockWeight: this.specification.stockWeight,
                lamination: this.specification.lamination
            };
            this.loading++;
            __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('specification', { params: params }).then(function (response) {
                _this4.loading--;
                // we're always pulling the first specification provided by POP
                // this may not be accurate but at this moment there is no
                // way to determine which specification is required
                _this4.popSpecification = response.data.results[0];
                _this4.specificationId = _this4.popSpecification.specificationId;
                if (callback) {
                    callback(true, response);
                }
            }).catch(function (error) {
                _this4.loading--;
                if (callback) {
                    callback(false, error);
                }
            });
        },
        fetchPrice: function fetchPrice(quantity, callback) {
            if (!this.popSpecification || quantity == 0) {
                return;
            }
            var params = {
                specificationId: this.popSpecification.specificationId,
                itemId: this.popSpecification.itemId,
                quantity: quantity
            };
            __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('price', { params: params }).then(function (response) {
                var price = parseFloat(response.data.results.totalPrice || 0);
                callback(true, price, response);
            }).catch(function (error) {
                callback(false, 0, error);
            });
        },
        fetchPriceTable: function fetchPriceTable() {
            var _this5 = this;

            this.priceTable.forEach(function (entry) {
                if (!_this5.shouldFetchEntryPrice(entry)) {
                    entry.price = 0;
                    entry.loading = false;
                } else if (entry.quantity == _this5.quantity && _this5.price > 0) {
                    entry.price = _this5.price;
                    entry.loading = false;
                } else {
                    entry.loading = true;
                    _this5.fetchPrice(entry.quantity, function (success, price, response) {
                        entry.price = price;
                        entry.loading = false;
                        if (response && response.data.results.minimumQuantity) {
                            _this5.$set(_this5.availableSpecification, 'min', response.data.results.minimumQuantity);
                        }
                        if (response && response.data.results.maximumQuantity) {
                            _this5.$set(_this5.availableSpecification, 'max', response.data.results.maximumQuantity);
                        }
                        // this.updateQuantity()
                    });
                }
            });
        },
        priceFetched: function priceFetched(price, response) {
            if (response.data && response.data.results && response.data.results.specificationId) {
                this.specificationId = response.data.results.specificationId;
            }
            this.price = price;
            if (response && response.data.results.minimumQuantity) {
                this.$set(this.availableSpecification, 'min', response.data.results.minimumQuantity);
            }
            if (response && response.data.results.maximumQuantity) {
                this.$set(this.availableSpecification, 'max', response.data.results.maximumQuantity);
            }
            if (price == 0 || response.data.error) {
                this.invalidQuantity = true;
                this.updateQuantity();
            }
        },
        fetchArtworkPrice: function fetchArtworkPrice() {
            var _this6 = this;

            this.design.loading = true;
            // fetch the artwork specification
            var params = {
                jobMethod: 'Artwork',
                description: this.product.alias,
                documentSize: this.specification.documentSize,
                extent: this.popSpecification.data.totalExtent,
                orientation: this.specification.orientation
            };
            __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('specification', { params: params }).then(function (response) {
                if (!response.data.results) {
                    _this6.design = { spec: 0, item: 0, price: 35, loading: false };
                    return;
                }
                var spec = response.data.results[0];
                _this6.design.spec = spec.specificationId;
                _this6.design.item = spec.itemId;
                var params = { specificationId: spec.specificationId, itemId: spec.itemId, quantity: 1 };
                __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('price', { params: params }).then(function (response) {
                    console.log('design price', response.data);
                    _this6.design.price = parseFloat(response.data.results.totalPrice || 35);
                    _this6.design.loading = false;
                }).catch(function (error) {
                    _this6.design = { spec: 0, item: 0, price: 35, loading: false };
                });
            }).catch(function (error) {
                _this6.design = { spec: 0, item: 0, price: 35, loading: false };
            });
        },
        fetchCarriagePrice: function fetchCarriagePrice() {
            var _this7 = this;

            this.carriage.loading = true;
            // fetch the carriage specification
            var params = { type: 'Delivery', category: this.product.alias };
            __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('specification', { params: params }).then(function (response) {
                if (!response.data.results) {
                    _this7.carriage = { spec: 0, item: 0, price: 35, loading: false };
                    return;
                }
                response.data.results.forEach(function (spec) {
                    if (spec.data.deliveryHours == 72) {
                        _this7.carriage.spec = spec.specificationId;
                        _this7.carriage.item = spec.itemId;
                        var _params = { specificationId: spec.specificationId, itemId: spec.itemId, quantity: 1 };
                        __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* POP */].get('price', { params: _params }).then(function (response) {
                            console.log('carriage price', response.data);
                            _this7.carriage.price = parseFloat(response.data.results.totalPrice || 6);
                            _this7.carriage.loading = false;
                        }).catch(function (error) {
                            console.log('Failed to get carriage price', error);
                            _this7.carriage = { spec: 0, item: 0, price: 6, loading: false };
                        });
                    }
                });
            }).catch(function (error) {
                _this7.carriage = { spec: 0, item: 0, price: 6, loading: false };
            });
        },
        createOrder: function createOrder() {
            this.placeOrder(this.finalPrice, this.quantity);
        },
        updateOrder: function updateOrder() {
            this.changeOrder(this.finalPrice, this.quantity);
        },
        changeOrder: function changeOrder(price, quantity) {
            var _this8 = this;

            var params = {
                product_id: this.productId, quantity: quantity, price: price, design_fee: this.design.price,
                specification_id: this.popSpecification.specificationId, design_specification_id: this.design.spec,
                specification: {
                    documentSize: this.specification.documentSize,
                    extent: this.specification.extent,
                    orientation: this.specification.orientation,
                    stockWeight: this.specification.stockWeight,
                    lamination: this.specification.lamination,
                    delivery: this.hasCarriage(),
                    artwork: this.artwork,
                    design: this.artwork == 2 && this.chosenArtwork ? this.chosenArtwork.image : null
                },
                design_specification: {
                    jobMethod: 'Artwork',
                    documentSize: this.specification.documentSize,
                    extent: this.popSpecification.data.totalExtent,
                    orientation: this.specification.orientation
                }
            };
            this.loading++;
            __WEBPACK_IMPORTED_MODULE_0__http_common__["b" /* POM */].patch('basket/order/' + this.orderId, params).then(function (response) {
                _this8.loading--;
                if (response.data.error) {
                    // TODO: show order error
                    return;
                }
                _this8.$router.push('/basket');
            }).catch(function (error) {
                // TODO: show order error
                _this8.loading--;
            });
        },
        placeOrder: function placeOrder(price, quantity) {
            var _this9 = this;

            var params = {
                product_id: this.productId, quantity: quantity, price: price, design_fee: this.design.price,
                specification_id: this.specificationId, design_specification_id: this.design.spec,
                delivery_specification_id: this.carriage.spec, delivery_item: this.carriage.item,
                specification: {
                    documentSize: this.specification.documentSize,
                    extent: this.specification.extent,
                    orientation: this.specification.orientation,
                    stockWeight: this.specification.stockWeight,
                    lamination: this.specification.lamination,
                    delivery: this.hasCarriage(),
                    artwork: this.artwork,
                    design: this.artwork == 2 && this.chosenArtwork ? this.chosenArtwork.image : null
                },
                design_specification: {
                    jobMethod: 'Artwork',
                    documentSize: this.specification.documentSize,
                    extent: this.popSpecification.data.totalExtent,
                    orientation: this.specification.orientation
                }
            };
            this.loading++;
            __WEBPACK_IMPORTED_MODULE_0__http_common__["b" /* POM */].post('basket/add', params).then(function (response) {
                _this9.loading--;
                if (response.data.error) {
                    // TODO: show order error
                    return;
                }
                _this9.$router.push('/basket');
            }).catch(function (error) {
                // TODO: show order error
                _this9.loading--;
            });
        },

        // delayed
        fetchPopSpecificationDelayed: _.debounce(function (callback) {
            return this.fetchPopSpecification(callback);
        }, 1500),
        fetchPriceDelayed: _.debounce(function (quantity, callback) {
            return this.fetchPrice(quantity, callback);
        }, 750),
        fetchArtworkPriceDelayed: _.debounce(function () {
            return this.fetchArtworkPrice();
        }, 750),
        fetchCarriagePriceDelayed: _.debounce(function () {
            return this.fetchCarriagePrice();
        }, 750),
        // helpers
        hasCarriage: function hasCarriage(quantity) {
            if (this.product.alias == 'Canvassing') {
                return quantity < 3000;
            } else if (this.product.alias == 'Minimags') {
                return quantity < 3000;
            } else if (this.product.alias == 'Brochure') {
                return false;
            } else if (this.product.alias == 'Folders') {
                return false;
            } else if (this.product.alias == 'Leaflets & Folded Cards') {
                return quantity < 3000;
            } else {
                return false;
            }
        },
        calculatedPrice: function calculatedPrice(price, quantity) {
            if (price <= 0) {
                return price;
            }
            if (this.hasCarriage(quantity)) {
                price += this.carriage.price;
            }
            if (this.artwork == 1 || this.artwork == 2) {
                price += this.design.price;
            }
            return price;
        },
        resetProduct: function resetProduct() {
            this.price = 0;
            this.order = null;
            this.invalidQuantity = false;
            this.resettingQuantity = false;
            this.availableSpecification = { documentSize: [], extent: [], orientation: [], stockWeight: [], lamination: [] };
            this.popSpecification = null;
            this.carouselIndex = 0;
            this.chosenArtwork = null;
            $('#carousel').carousel(0);
        },
        shouldFetchEntryPrice: function shouldFetchEntryPrice(entry) {
            if (this.availableSpecification.min && this.availableSpecification.max) {
                return entry.quantity > this.availableSpecification.min && entry.quantity < this.availableSpecification.max;
            }
            return true;
        },
        findClosestQuantity: function findClosestQuantity(quantity) {
            var closest = 0;
            var previous = null;
            this.priceTable.filter(function (entry) {
                return entry.price > 0;
            }).forEach(function (entry, index) {
                var diff = entry.quantity - quantity;
                // ensure the value is positive
                if (diff < 0) diff *= -1;
                if (previous == null || diff <= previous) {
                    previous = diff;
                    closest = entry.quantity;
                }
            });
            return closest;
        },
        updateQuantity: function updateQuantity() {
            if (this.price > 0) {
                return;
            }
            // check the quantity, adjust if needed
            this.resettingQuantity = true;
            if (this.availableSpecification.min && this.availableSpecification.min > this.quantity) {
                this.quantity = this.availableSpecification.min;
            } else if (this.availableSpecification.max && this.availableSpecification.max < this.quantity) {
                this.quantity = this.availableSpecification.max;
            } else {
                var entry = this.findClosestQuantity(this.quantity);
                if (entry > 0) {
                    this.quantity = entry;
                } else {
                    this.invalidQuantity = true;
                }
            }
        },
        resetInvalidQuantity: function resetInvalidQuantity() {
            this.invalidQuantity = false;
        },
        goToCarouselImage: function goToCarouselImage(index) {
            this.carouselIndex = index;
            $('#carousel').carousel(index);
        },
        designSelected: function designSelected(design) {
            this.chosenArtwork = design;
        }
    },
    watch: {
        $route: function $route() {
            this.fetchProduct();
            // this.fetchOrder()
        },
        loading: function loading(newVal) {
            if (newVal < 0) {
                this.loading = 0;
            }
        },

        specification: {
            handler: function handler() {
                var _this10 = this;

                this.invalidQuantity = false;
                this.price = 0;
                this.availableSpecification.min = null;
                this.availableSpecification.max = null;
                this.priceTable.forEach(function (entry) {
                    entry.loading = true;
                    entry.price = 0;
                });
                this.fetchPopSpecificationDelayed(function (success, data) {
                    if (success) {
                        // this.priceTable.forEach(entry => entry.loading = true)
                        _this10.fetchPrice(_this10.quantity, function (success, price, response) {
                            _this10.priceFetched(price, response);
                            _this10.fetchPriceTable();
                        });
                        _this10.fetchArtworkPrice();
                    }
                });
                this.fetchCarriagePriceDelayed();
            },

            deep: true
        },
        quantity: function quantity() {
            var _this11 = this;

            if (!this.resettingQuantity) {
                this.invalidQuantity = false;
            }
            this.price = 0;
            this.fetchPriceDelayed(this.quantity, function (success, price, response) {
                _this11.priceFetched(price, response);
            });
            this.resettingQuantity = false;
        }
    },
    created: function created() {
        this.fetchProduct();
        // this.fetchOrder()
        this.$root.$on('design::selected', this.designSelected);
    },
    mounted: function mounted() {
        var component = this;
        window.setTimeout(function () {
            $('#carousel').on('slide.bs.carousel', function (e) {
                component.carouselIndex = e.to;
            });
        }, 1000);
    },
    beforeDestroy: function beforeDestroy() {
        this.$root.$off('design::selected', this.designSelected);
    }
});

/***/ }),

/***/ "8ZdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inspiration_modal_vue__ = __webpack_require__("c1W7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3071fa04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inspiration_modal_vue__ = __webpack_require__("+nIc");
function injectStyle (ssrContext) {
  __webpack_require__("vvwx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3071fa04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inspiration_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3071fa04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inspiration_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mega-nav navbar navbar-expand-lg navbar-collapse-sm navbar-light bg-faded",attrs:{"role":"navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"navbar-header col-md-12 col-lg-2"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{name:'Dashboard'},"title":"The Guild of Property Professionals"}},[_c('img',{attrs:{"src":_vm.system.logo,"alt":"The Guild of Property Professionals"}})]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col forceStatic"},[_c('div',{staticClass:"row text-right"},[_c('div',{staticClass:"col-md-12"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "+_vm._s(_vm.user.officeName)+"\n                        "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"text-danger ml-2",attrs:{"title":"Logout"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-power-off",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.searchResults.length > 0)?_c('div',{staticClass:"searchResultsContainer"},_vm._l((_vm.searchResults),function(searchResult){return _c('li',[_c('router-link',{staticClass:"agentColour2TextHover",attrs:{"to":{name: 'Order', params:{productId:searchResult.id}}}},[_vm._v("\n                                    "+_vm._s(searchResult.name)+"\n                                ")])],1)})):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row text-right"},[_c('div',{staticClass:"col-md-12 forceStatic"},[_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',[_c('router-link',{attrs:{"to":{name:'Dashboard'}}},[_vm._v("\n                                        Dashboard\n                                    ")])],1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler navbar-toggler-center pull-right",attrs:{"type":"button","data-toggle":"collapse","data-target":".navbar-collapse"}},[_c('i',{staticClass:"fa fa-bars icon-custom"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8o1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var POP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    // baseURL: '//dev.pop-api.propertylogic.net/api/v1/'
    baseURL: '//pop-api.propertylogic.net/api/v1/'
});

var POM = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: '/api/'
});

/***/ }),

/***/ "9DWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'login',
    data: function data() {
        return {
            username: "",
            password: "",
            errors: []
        };
    },
    methods: {
        login: function login() {
            var _this = this;

            this.axios.post('/api/user/login', {
                username: this.$data.username,
                password: this.$data.password
            }).then(function (response) {
                _this.$router.push({ path: "/" });
            }).catch(function (e) {
                if (e.response.status === 422) {
                    _this.$data.errors = e.response.data;
                }
            });
        }
    }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BtVQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EnAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    //
});

/***/ }),

/***/ "IkE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"text-uppercase"},[_vm._v("My Favourites")]),_vm._v(" "),(!_vm.hasFavourites)?_c('p',{staticClass:"text-muted"},[_vm._v("\n                You have no favourites for the selected product\n            ")]):_vm._l((_vm.favouriteGroups),function(group,index){return _c('div',{key:index,staticClass:"row text-center"},_vm._l((group),function(style){return _c('div',{key:style.id,staticClass:"col-6 col-md-4 col-lg-2 inspiration-card d-flex flex-column align-items-center justify-content-end"},[(_vm.selectedProduct == 'all')?_c('small',[_vm._v(_vm._s(_vm.productMap[style.product_id].name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"img-box-container"},[(_vm.zoom && _vm.type != 'choose-your-design')?_c('div',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('zoom_fav_' + style.id),expression:"'zoom_fav_' + style.id"}],staticClass:"img-box-overlay"},[_c('i',{staticClass:"fa fa-search-plus fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.type == 'choose-your-design')?_c('div',{staticClass:"img-box-overlay",on:{"click":function($event){_vm.select(style)}}},[_c('i',{staticClass:"fa fa-check fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":style.image}})]),_vm._v(" "),_c('b-modal',{attrs:{"id":'zoom_fav_' + style.id,"size":"lg","hide-header":"","hide-footer":""}},[(style.url)?_c('a',{attrs:{"href":style.url,"target":"_blank"}},[_c('div',{staticClass:"full"},[_c('iframe',{attrs:{"src":style.url,"frameborder":"0"}})])]):_c('img',{staticClass:"img-fluid img-lh",attrs:{"src":style.image}}),_vm._v(" "),_c('button',{ref:"modalClose",refInFor:true,staticClass:"btn modal-close",attrs:{"type":"button"},on:{"click":function($event){_vm.close('zoom_fav_' + style.id)}}},[_c('i',{staticClass:"fa fa-times fa-lg",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.type == 'inspiration')?_c('b-btn',{staticClass:"mt-2 color-blue",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.unlike(style.id)}}},[_c('i',{staticClass:"fa fa-heart",attrs:{"aria-hidden":"true"}}),_vm._v(" Like\n                    ")]):_vm._e()],1)}))})],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-3"},[_c('h6',{staticClass:"text-uppercase"},[_vm._v("Filter designs by:")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.productOptions},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}})],1)]),_vm._v(" "),_vm._l((_vm.styleGroups),function(group,index){return _c('div',{key:index,staticClass:"row text-center"},_vm._l((group),function(style){return _c('div',{key:style.id,staticClass:"col-6 col-md-4 col-lg-2 inspiration-card d-flex flex-column align-items-center justify-content-end"},[_c('div',{staticClass:"img-box-container"},[(_vm.zoom && _vm.type != 'choose-your-design')?_c('div',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('zoom_' + style.id),expression:"'zoom_' + style.id"}],staticClass:"img-box-overlay"},[_c('i',{staticClass:"fa fa-search-plus fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.type == 'choose-your-design')?_c('div',{staticClass:"img-box-overlay",on:{"click":function($event){_vm.select(style)}}},[_c('i',{staticClass:"fa fa-check fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":style.image}})]),_vm._v(" "),_c('b-modal',{attrs:{"id":'zoom_' + style.id,"size":"lg","hide-header":"","hide-footer":""}},[(style.url)?_c('a',{attrs:{"href":style.url,"target":"_blank"}},[_c('div',{staticClass:"full"},[_c('iframe',{attrs:{"src":style.url,"frameborder":"0"}})])]):_c('img',{staticClass:"img-fluid img-lh",attrs:{"src":style.image}}),_vm._v(" "),_c('button',{ref:"modalClose",refInFor:true,staticClass:"btn modal-close",attrs:{"type":"button"},on:{"click":function($event){_vm.close('zoom_' + style.id)}}},[_c('i',{staticClass:"fa fa-times fa-lg",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.type == 'inspiration')?_c('b-btn',{staticClass:"mt-2 color-blue",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.like(style.id)}}},[_c('i',{staticClass:"fa fa-heart-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Like\n            ")]):_vm._e()],1)}))})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 mr-3"},[_c('h1',[_vm._v("Inspire Me")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Take a look at some of the designs we have done for other clients. We’ll base your design off the styles you like.")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("faPJ"),"alt":"we_heart_design_print"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Imy4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iu8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bottom-footer"},[_c('div',{staticClass:"sitemap-container"},[_c('b-container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"})])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Contact Us")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('ul')])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('ul')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('ul',[_c('li',[_vm._v("t:\n                                        "),_c('a',{attrs:{"href":'tel:' + _vm.system.phone}},[_vm._v(_vm._s(_vm.system.phone))])]),_vm._v(" "),_c('li',[_vm._v("e:\n                                        "),_c('router-link',{attrs:{"to":{name:'Contact'}}},[_vm._v(_vm._s(_vm.system.email_address))])],1),_vm._v(" "),_c('li',[_vm._v("a:\n                                        "),_c('a',{attrs:{"href":'https://maps.google.com/?q=' + _vm.system.address,"target":"_blank"}},[_vm._v(_vm._s(_vm.system.address))])])])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"terms-container"},[_c('b-container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center text-md-left pb-5 pb-md-0"},[_c('router-link',{attrs:{"to":{name: 'terms'}}},[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'privacy-policy'}}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'cookie-policy'}}},[_vm._v("Cookie Policy")])],1)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JReE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main mt-5",domProps:{"innerHTML":_vm._s(_vm.terms)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JTfW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JtxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navpage',
  data: function data() {
    return {
      msg: 'Welcome to the navpage'
    };
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c9ac501_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("10El");
function injectStyle (ssrContext) {
  __webpack_require__("Imy4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c9ac501_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRLu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_nav_nav__ = __webpack_require__("ZQHB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_bottom_footer_bottom_footer__ = __webpack_require__("181b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_inspiration_modal_inspiration_modal__ = __webpack_require__("8ZdU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_customer_finder_customer_finder__ = __webpack_require__("8Bi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__http_common__ = __webpack_require__("8o1w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_js__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_promise_polyfill__ = __webpack_require__("MF5+");


















// To add to window
if (!window.Promise) {
    window.Promise = __WEBPACK_IMPORTED_MODULE_14_promise_polyfill__["a" /* default */];
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('navigation', __WEBPACK_IMPORTED_MODULE_6__components_modules_nav_nav__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('bottom-footer', __WEBPACK_IMPORTED_MODULE_7__components_modules_bottom_footer_bottom_footer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('inspiration-modal', __WEBPACK_IMPORTED_MODULE_8__components_modules_inspiration_modal_inspiration_modal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('customer-finder', __WEBPACK_IMPORTED_MODULE_9__components_modules_customer_finder_customer_finder__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.name === "login") {
        next();
        return;
    }

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/user').then(function (response) {
        next();
    }).catch(function (e) {
        if (e.response.status === 401) {
            console.warn("NOT LOGGED IN", to, from, next);
            next('login');
        } else {
            next(e);
        }
    });
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function (to, from, next) {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] },
    data: {
        system: {},
        spec: {}
    },
    created: function created() {
        var _this = this;

        this.axios.get("/api/system").then(function (response) {
            // console.log('system', response)
            _this.system = response.data;
        }).catch(function (error) {
            console.log(error);
        });
        /*this.axios.get("http://dev.pop-api.propertylogic.net/api/v1/specification", {
          withCredentials: false
        })*/
        __WEBPACK_IMPORTED_MODULE_10__http_common__["a" /* POP */].get('specification').then(function (response) {
            // console.log(response)
            response.data.results.forEach(function (item) {
                _this.spec[item.specificationId] = item;
            });
        }).catch(function (error) {
            console.log(error);
        });
    }
});

/***/ }),

/***/ "NMYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__ = __webpack_require__("URo1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc483f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_dashboard_html__ = __webpack_require__("68I3");
function injectStyle (ssrContext) {
  __webpack_require__("VmYw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cc483f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc483f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_dashboard_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NQ4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'inspiration',
    props: {
        type: { default: 'inspiration', type: String },
        zoom: { default: false, type: Boolean },
        selected: { default: null }
    },
    data: function data() {
        return {
            products: [],
            productMap: {},
            selectedProduct: 'all',
            styles: [],
            favourites: []
        };
    },

    computed: {
        hasFavourites: function hasFavourites() {
            // return this.favourites.length > 0;
            return this.favouritesStyles.length > 0;
        },
        productStyles: function productStyles() {
            var _this = this;

            if (this.selectedProduct == 'all') {
                return this.styles;
            }
            return this.styles.filter(function (style) {
                return style.product_id == _this.selectedProduct;
            });
        },
        stylesWithoutFavourites: function stylesWithoutFavourites() {
            var _this2 = this;

            return this.productStyles.filter(function (style) {
                return _this2.favourites.indexOf(style.id) == -1;
            });
        },
        favouritesStyles: function favouritesStyles() {
            var _this3 = this;

            return this.productStyles.filter(function (style) {
                return _this3.favourites.indexOf(style.id) != -1;
            });
        },

        styleGroups: function styleGroups() {
            var groups = [];
            for (var i = 0; i < this.stylesWithoutFavourites.length; i += 6) {
                groups.push(this.stylesWithoutFavourites.slice(i, i + 6));
            }
            return groups;
        },
        favouriteGroups: function favouriteGroups() {
            var groups = [];
            for (var i = 0; i < this.favouritesStyles.length; i += 6) {
                groups.push(this.favouritesStyles.slice(i, i + 6));
            }
            return groups;
        },
        productOptions: function productOptions() {
            var options = [{ value: 'all', text: 'All' }];
            // console.log('products', this.products);
            this.products.forEach(function (product) {
                options.push({ value: product.id, text: product.name });
            });
            return options;
        }
    },
    methods: {
        close: function close(modalId) {
            this.$root.$emit('bv::hide::modal', modalId);
        },
        logo: function logo(id) {
            return 'https://services.propertylogic.net/images/pom/' + id + '.jpg';
        },
        fetch: function fetch() {
            var _this4 = this;

            // fetch the products
            this.axios.get('/api/product').then(function (response) {
                // console.log('products response', response);
                _this4.products = response.data;
                _this4.products.forEach(function (product) {
                    _this4.productMap[product.id] = product;
                });
                // this.selectedProduct = this.products[0].id
            }).catch(function (error) {
                console.log(error);
            });

            // fetch the designs
            this.axios.get('/api/design').then(function (response) {
                // console.log(response);
                _this4.styles = response.data;
            }).catch(function (error) {
                console.log(error);
            });

            // fetch the liked designs
            this.axios.get('/api/design-like').then(function (response) {
                // console.log(response);
                _this4.favourites = response.data.likes;
                if (_this4.selected) {
                    _this4.selectedProduct = _this4.selected;
                } else {
                    _this4.selectedProduct = response.data.fav_product;
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        like: function like(id) {
            this.favourites.push(id);
            this.axios.post('/api/design-like/add', {
                design_id: id
            }).then(function (response) {
                // console.log(response)
            }).catch(function (error) {
                console.log(error);
            });
        },
        unlike: function unlike(id) {
            this.favourites.splice(this.favourites.indexOf(id), 1);
            this.axios.post('/api/design-like/remove', {
                design_id: id
            }).then(function (response) {
                // console.log(response)
            }).catch(function (error) {
                console.log(error);
            });
        },
        select: function select(style) {
            this.$root.$emit('design::selected', style);
            this.$root.$emit('bv::hide::modal', 'inspiration');
        }
    },
    mounted: function mounted() {
        this.fetch();
    }
});

/***/ }),

/***/ "NgvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OihP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_not_found_vue__ = __webpack_require__("EnAn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2fdf41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_not_found_vue__ = __webpack_require__("uHln");
function injectStyle (ssrContext) {
  __webpack_require__("hFNX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b2fdf41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_not_found_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2fdf41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OyDo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1x/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 ml-md-auto mr-md-auto"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                        Login\n                    ")]),_vm._v(" "),_c('form',{staticClass:"card-body",on:{"submit":function($event){$event.preventDefault();_vm.login()}}},[(_vm.errors.length > 0)?_c('div',{staticClass:"alert alert-danger"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"loginUsername"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","id":"loginUsername"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"loginPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"loginPassword"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                            Login\n                        ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ROGF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Artwork Requirements")]),_vm._v(" "),_c('h3',[_vm._v("Canvassing Cards")]),_vm._v(" "),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TEnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "URo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',
    data: function data() {
        return {
            reviews: [],
            popularProducts: [],
            errors: []
        };
    },

    computed: {
        system: function system() {
            return this.$root.$data.system;
        },
        heading: function heading() {
            if (this.system && this.system.dashboard && this.system.dashboard.hero && this.system.dashboard.hero.heading) {
                return this.system.dashboard.hero.heading;
            }
            return "All your print requirements<br />in <strong>one place.</strong>";
        },
        heroImageOverride: function heroImageOverride() {
            if (this.system && this.system.dashboard && this.system.dashboard.hero && this.system.dashboard.hero.image) {
                return "background-image: url('" + this.system.dashboard.hero.image + "')";
            }
            return "";
        }
    },
    methods: {
        heroButtonClass: function heroButtonClass() {
            var num = this.system.dashboard.hero.features.length + 1;
            if (num > 10) {
                num = 10;
            }
            return ['delay-' + num];
        },
        moveCarousel: function moveCarousel(event) {
            var currentPosition = event.currentTarget.getAttribute('data-order');
            var movePosition = 3 - currentPosition;
            var totalReviewsNo = this.reviews.length;

            for (var i = 0; i < totalReviewsNo; i++) {
                var newPosition = this.reviews[i].order + movePosition;

                if (totalReviewsNo > 5 && newPosition < 0 || newPosition < 1) {
                    newPosition = totalReviewsNo + newPosition;
                }
                if (newPosition > totalReviewsNo) {
                    newPosition = newPosition - totalReviewsNo;
                }

                this.reviews[i].order = newPosition;
            }
        }
    },
    // TODO: change the api urls to eg:(/api/testimonials) etc.
    // TODO: hook in the products after the Products model is done
    mounted: function mounted() {
        var _this = this;

        this.axios.get('/api/testimonials').then(function (response) {

            response.data.data.forEach(function (v, i) {
                v.order = i + 1;
            });

            _this.reviews = response.data.data;
        }).catch(function (e) {
            _this.errors.push(e);
        });

        this.axios.get('/api/popular-products').then(function (response) {
            _this.popularProducts = response.data;
        }).catch(function (e) {
            _this.errors.push(e);
        });
    }
});

/***/ }),

/***/ "VFgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_terms__ = __webpack_require__("mp5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__artwork_requirements_artwork_requirements__ = __webpack_require__("584s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_common__ = __webpack_require__("8o1w");




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'basket',
    components: { Terms: __WEBPACK_IMPORTED_MODULE_0__terms_terms__["a" /* default */], ArtworkRequirements: __WEBPACK_IMPORTED_MODULE_1__artwork_requirements_artwork_requirements__["a" /* default */] },
    data: function data() {
        return {
            complete: false,
            loading: true,
            sending: false,
            terms: false,
            assetUploads: 0,
            error: { show: false, message: '' },
            price_error: { show: false, message: null },
            order: { ref: '', ref_name: '', studio_instructions: '', design: '', basket: { items: [], design_fee: 0 } }
        };
    },

    computed: {
        canConfirm: function canConfirm() {
            return this.terms && this.order.ref_name.length > 0 && this.order.basket.items.length > 0 && this.valid;
        },
        spec: function spec() {
            return this.$root.$data.spec;
        },
        price: function price() {
            if (this.order.basket.items.length == 0) return 0;
            var final = 0;
            this.order.basket.items.forEach(function (item) {
                final += item.price;
            });
            return final;
        },
        vat: function vat() {
            return this.price == 0 ? 0 : this.price * 0.2;
        },
        valid: function valid() {
            var isValid = true;
            for (var i = 0; i < this.order.basket.items.length; i++) {
                var item = this.order.basket.items[i];
                if (!item.send_later) {
                    isValid = item.asset != null;
                    if (!isValid) break;
                }
            }
            return isValid;
        }
    },
    methods: {
        fetch: function fetch() {
            var _this = this;

            this.axios.get('/api/basket').then(function (response) {
                _this.order.basket = response.data;
                _this.order.basket.design_fee = 0;
                _this.transformBasketData();
                _this.loading = false;
            }).catch(function (error) {
                console.log(error);
                _this.loading = false;
            });
        },
        transformBasketData: function transformBasketData() {
            var _this2 = this;

            this.order.basket.items.forEach(function (item) {
                _this2.$set(item, 'send_later', true);
                _this2.$set(item, 'asset', null);
            });
        },
        remove: function remove(item) {
            var _this3 = this;

            this.loading = true;
            this.order.basket.items.splice(this.order.basket.items.indexOf(item), 1);
            this.axios.post('/api/basket/remove', {
                id: item.id
            }).then(function (response) {
                _this3.loading = false;
                // this.fetch()
            }).catch(function (error) {
                _this3.loading = false;
                _this3.fetch();
            });
        },

        update: _.debounce(function (item) {
            var _this4 = this;

            this.loading = true;
            this.axios.patch('/api/basket/update', {
                id: item.id, quantity: item.quantity
            }).then(function (response) {
                var updated = response.data.item;
                _this4.$set(item, 'price', updated.price);
                _this4.$set(item, 'quantity', updated.quantity);
                _this4.price_error = { show: false, message: null };
                _this4.loading = false;
            }).catch(function (error) {
                _this4.price_error = { show: true, message: error.response.data.pop.message };
                _this4.loading = false;
            });
        }, 500),
        confirm: function confirm() {
            var _this5 = this;

            this.loading = true;
            this.sending = true;
            var items = {};
            this.order.basket.items.forEach(function (item) {
                items[item.id] = item;
            });
            this.axios.post('/api/basket/order', {
                'ref_name': this.order.ref_name,
                'studio_instructions': this.order.studio_instructions,
                'chosen_design': this.order.design,
                'sub_total': this.price,
                'total': this.price + this.vat
            }).then(function (response) {
                _this5.order.ref = response.data.ref;
                response.data.items.forEach(function (item) {
                    _this5.assetUploads++;
                    var fd = new FormData();
                    fd.append('assetFile', items[item.id].asset);
                    console.log('uploading asset..', item.line, item.id);
                    __WEBPACK_IMPORTED_MODULE_2__http_common__["a" /* POP */].post('/asset/upload/' + item.line, fd).then(function (response) {
                        _this5.assetUploads--;
                    }).catch(function (e) {
                        console.log(e);
                        _this5.complete = true;
                        _this5.loading = false;
                        _this5.sending = false;
                    });
                });
                if (_this5.assetUploads == 0) {
                    _this5.complete = true;
                    _this5.loading = false;
                    _this5.sending = false;
                }
            }).catch(function (error) {
                console.log(error);
                _this5.loading = false;
                _this5.sending = false;
                _this5.error = { show: true, message: "We've been unable to complete your order at this time, try again later." };
            });
        },
        getItemQuantities: function getItemQuantities(item) {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_2__http_common__["a" /* POP */].get('price', {
                params: { specificationId: item.specification_id, itemId: item.product.direct_mail_item_id, quantity: item.quantity }
            }).then(function (response) {
                console.log('pop-price', response);
                if (response.data.error) return;
                _this6.$set(item, 'min_quantity', response.data.results.minimumQuantity);
                _this6.$set(item, 'max_quantity', response.data.results.maximumQuantity);
            }).catch(function (error) {
                console.log('pop-price', error);
            });
        },
        closeModal: function closeModal(ref) {
            this.$root.$emit('bv::hide::modal', ref);
        },
        designSelected: function designSelected(design) {
            // console.log('design', design)
            this.order.design = design.image;
        }
    },
    created: function created() {
        this.$root.$on('design::selected', this.designSelected);
    },
    beforeDestroy: function beforeDestroy() {
        this.$root.$off('design::selected', this.designSelected);
    },
    mounted: function mounted() {
        this.fetch();
    },

    watch: {
        assetUploads: function assetUploads(uploads) {
            if (uploads <= 0) {
                this.complete = true;
                this.loading = false;
                this.sending = false;
                this.assetUploads = 0;
            }
        }
    }
});

/***/ }),

/***/ "VmYw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WF1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navpage_vue__ = __webpack_require__("JtxA");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d74672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navpage_vue__ = __webpack_require__("NgvP");
function injectStyle (ssrContext) {
  __webpack_require__("BtVQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38d74672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d74672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "WKCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'contact',
    data: function data() {
        return {
            sent: false,
            sending: false
        };
    },

    computed: {
        system: function system() {
            return this.$root.$data.system;
        }
    },
    methods: {
        send: function send(event) {
            var _this = this;

            this.sending = true;
            var form = event.target;
            var data = {
                "name": form.name.value, "email": form.email.value,
                "phone": form.phone.value, "message": form.message.value
            };
            this.axios.post('/api/contact', data).then(function (response) {
                // console.log(response)
                _this.sent = true;
                _this.sending = false;
            }).catch(function (error) {
                console.log(error);
                _this.sent = false;
                _this.sending = false;
            });
        }
    }
});

/***/ }),

/***/ "WfPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wfi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name:'Contact'}}},[_c('div',{staticClass:"find d-flex align-items-center"},[_c('img',{attrs:{"src":__webpack_require__("5nkz"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_vm._v("\n            Need help finding what you're looking for? "),_c('small',{staticClass:"text-uppercase"},[_vm._v("Click here")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YOML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bottom-footer',
    data: function data() {
        return {
            products: [],
            system: [],
            user: []
        };
    },

    methods: {
        fetch: function fetch() {
            var _this = this;

            // fetch the products
            this.axios.get('/api/product').then(function (response) {
                _this.products = response.data;
                _this.selectedProduct = _this.products[0].id;
            }).catch(function (error) {
                console.log(error);
            });
            // fetch the system info
            this.axios.get('/api/system').then(function (response) {
                _this.system = response.data;
            }).catch(function (error) {
                console.log(error);
            });
            // fetch the user
            this.axios.get('/api/user').then(function (response) {
                _this.user = response.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted: function mounted() {
        this.fetch();
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_login_login__ = __webpack_require__("si4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_dashboard__ = __webpack_require__("NMYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_order_order_new__ = __webpack_require__("7s5t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_products_products__ = __webpack_require__("mIQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_inspiration_inspiration__ = __webpack_require__("o7ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_basket_basket__ = __webpack_require__("3UWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_navpage_navpage__ = __webpack_require__("WF1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_terms_terms__ = __webpack_require__("mp5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_not_found_not_found__ = __webpack_require__("OihP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_contact_contact_vue__ = __webpack_require__("oA8d");













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/login',
        name: 'login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_login_login__["a" /* default */]
    }, {
        path: '/',
        name: 'Dashboard',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_dashboard__["a" /* default */]
    }, {
        path: '/order/:productId',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_order_order_new__["a" /* default */],
        props: true
    }, {
        path: '/order/:productId/:orderId',
        name: 'EditOrder',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_order_order_new__["a" /* default */],
        props: true
    }, {
        path: '/products',
        name: 'Products',
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_products_products__["a" /* default */]
    }, {
        path: '/inspiration',
        name: 'Inspiration Board',
        component: __WEBPACK_IMPORTED_MODULE_6__components_pages_inspiration_inspiration__["a" /* default */],
        props: { zoom: true }
    }, {
        path: '/basket',
        name: 'Basket',
        component: __WEBPACK_IMPORTED_MODULE_7__components_pages_basket_basket__["a" /* default */]
    }, {
        path: '/terms',
        name: 'terms',
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_terms_terms__["a" /* default */],
        props: { termType: 'terms' }
    }, {
        path: '/cookie-policy',
        name: 'cookie-policy',
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_terms_terms__["a" /* default */],
        props: { termType: 'cookie-policy' }
    }, {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: __WEBPACK_IMPORTED_MODULE_9__components_pages_terms_terms__["a" /* default */],
        props: { termType: 'privacy-policy' }
    }, {
        path: '/contact',
        name: 'Contact',
        component: __WEBPACK_IMPORTED_MODULE_11__components_pages_contact_contact_vue__["a" /* default */]
    }, {
        // NB: This needs to be the last route!
        path: "*",
        component: __WEBPACK_IMPORTED_MODULE_10__components_pages_not_found_not_found__["a" /* default */]
    }]
}));

/***/ }),

/***/ "YgiE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__ = __webpack_require__("7nwu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07da94ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_nav_html__ = __webpack_require__("8bfx");
function injectStyle (ssrContext) {
  __webpack_require__("MRLu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07da94ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07da94ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_nav_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "abGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_cannot_find_button_cannot_find_button__ = __webpack_require__("zxIB");
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'products',
    components: { CannotFindButton: __WEBPACK_IMPORTED_MODULE_0__modules_cannot_find_button_cannot_find_button__["a" /* default */] },
    data: function data() {
        return {
            products: [],
            reviews: [],
            errors: []
        };
    },


    methods: {
        moveCarousel: function moveCarousel(event) {
            var currentPosition = event.currentTarget.getAttribute('data-order');
            var movePosition = 3 - currentPosition;
            var totalReviewsNo = this.reviews.length;

            for (var i = 0; i < totalReviewsNo; i++) {
                var newPosition = this.reviews[i].order + movePosition;

                if (totalReviewsNo > 5 && newPosition < 0 || newPosition < 1) {
                    newPosition = totalReviewsNo + newPosition;
                }
                if (newPosition > totalReviewsNo) {
                    newPosition = newPosition - totalReviewsNo;
                }

                this.reviews[i].order = newPosition;
            }
        }
    },

    mounted: function mounted() {
        var _this = this;

        this.axios.get('/api/product').then(function (response) {
            _this.products = response.data;
        }).catch(function (e) {
            _this.errors.push(e);
        });

        this.axios.get('/api/testimonials').then(function (response) {

            response.data.data.forEach(function (v, i) {
                v.order = i + 1;
            });

            _this.reviews = response.data.data;
        }).catch(function (e) {
            _this.errors.push(e);
        });
    }
});

/***/ }),

/***/ "aoyh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bi2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c1W7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_inspiration_inspiration__ = __webpack_require__("o7ng");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



$.fn.extend({
    animateCss: function animateCss(animationName, onEnd) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);
            onEnd();
        });
        return this;
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'inspiration-modal',
    components: { Inspiration: __WEBPACK_IMPORTED_MODULE_0__pages_inspiration_inspiration__["a" /* default */] },
    props: {
        type: { default: 'inspiration', type: String },
        selected: { default: null }
    },
    methods: {
        close: function close() {
            this.$root.$emit('bv::hide::modal', 'inspiration');
        },
        animate: function animate() {
            var that = this;
            $('#pencil').animateCss('jello', function () {
                setTimeout(function () {
                    that.animate();
                }, 2000);
            });
        }
    },
    mounted: function mounted() {
        this.animate();
    }
});

/***/ }),

/***/ "dYah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.complete)?_c('div',{staticClass:"container-fluid mt-5"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered mb-4"},[_vm._m(1),_vm._v(" "),(_vm.loading && _vm.order.basket.items.length == 0)?_c('tbody',[_c('transition',{attrs:{"name":"fade"}},[_c('tr',[_c('td',{staticClass:"align-middle text-center py-5",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw"})])])])],1):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.order.basket.items.length == 0)?_c('tbody',[_c('transition',{attrs:{"name":"fade"}},[_c('tr',[_c('td',{staticClass:"align-middle text-center py-5",attrs:{"colspan":"3"}},[_c('router-link',{staticClass:"h4 text-info",attrs:{"to":"/products"}},[_vm._v("Add some items to your basket")])],1)])])],1):_c('tbody',_vm._l((_vm.order.basket.items),function(item){return _c('tr',{key:item.id},[_c('td',{staticClass:"align-middle",staticStyle:{"min-width":"300px"}},[_c('div',{staticClass:"d-flex flex-column flex-xl-row"},[_c('img',{staticClass:"align-self-center img-fluid rounded mr-4 mb-3 mb-xl-0",staticStyle:{"max-width":"120px"},attrs:{"src":item.product.thumbnail}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"flex":"1"}},[_c('strong',[_vm._v(_vm._s(item.quantity)+"x "+_vm._s(item.specification.documentSize)+" "+_vm._s(item.product.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.specification.stockWeight)+"GSM, "+_vm._s(item.specification.orientation)+", "+_vm._s(item.specification.lamination)+" Laminated")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-around",staticStyle:{"flex":"0.2"}},[_c('router-link',{staticClass:"point text-info",attrs:{"to":{ name: 'EditOrder', params: { productId: item.product.id, orderId: item.id }}}},[_c('i',{staticClass:"fa fa-pencil fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{staticClass:"point text-danger",on:{"click":function($event){_vm.remove(item)}}},[_c('i',{staticClass:"fa fa-trash-o fa-lg",attrs:{"aria-hidden":"true"}})])],1)])])]),_vm._v(" "),(item.specification.artwork == 1 && item.design_fee)?_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('span',[_vm._v("Design it for me!")]),_vm._v(" "),_c('small',[_c('span',{staticClass:"font-weight-bold text-info"},[_vm._v(_vm._s(_vm._f("currency")(item.design_fee)))]),_vm._v(" additional cost added")])])]):_vm._e(),_vm._v(" "),(item.specification.artwork == 2 && item.design_fee)?_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"d-flex justify-content-around"},[_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center align-items-xl-start mb-2 mb-xl-0"},[_c('span',[_vm._v("Template Chosen")]),_vm._v(" "),_c('small',[_c('span',{staticClass:"font-weight-bold text-info"},[_vm._v(_vm._s(_vm._f("currency")(item.design_fee)))]),_vm._v(" additional cost added")])]),_vm._v(" "),_c('img',{staticClass:"align-self-center img-fluid rounded mr-4 mb-3 mb-xl-0",staticStyle:{"max-width":"120px"},attrs:{"src":item.specification.design}})])]):_vm._e(),_vm._v(" "),(item.specification.artwork == 0)?_c('td',{staticClass:"align-middle"},[_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('b-form-file',{attrs:{"id":"file","choose-label":"Upload","disabled":item.send_later},model:{value:(item.asset),callback:function ($$v) {_vm.$set(item, "asset", $$v)},expression:"item.asset"}}),_vm._v(" "),_c('span',{staticClass:"ml-2 badge badge-pill badge-info text-light",staticStyle:{"cursor":"pointer"},attrs:{"id":"artwork_requirements"}},[_vm._v("i")]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"artwork_requirements","placement":"left"}},[_vm._v("\n                                Artwork must be supplied print ready, and contain 3mm crops and bleed around the edges.\n                            ")])],1),_vm._v(" "),_c('small',{staticClass:"mt-1"},[_vm._v("Click, or drag and drop your files here")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-2 text-info",model:{value:(item.send_later),callback:function ($$v) {_vm.$set(item, "send_later", $$v)},expression:"item.send_later"}},[_c('span',{staticClass:"font-size-sm"},[_vm._v("I'll send artwork later")])])],1)]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('span',{staticClass:"h3 font-weight-bold text-info"},[_vm._v(_vm._s(_vm._f("currency")(item.price)))]),_vm._v(" "),_c('small',[_vm._v("ex.VAT")])])])}))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col d-flex align-items-end justify-content-between"},[_c('h6',[_vm._v("Instructions for 'The Studio'")]),_vm._v(" "),_c('inspiration-modal')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-form-textarea',{staticClass:"font-size-sm",attrs:{"id":"design-desc","rows":10,"max-rows":16,"placeholder":"Please give 'The Studio' any guidance you can on what you would like to include in the design, the message you would like to deliver and what style of card you require."},model:{value:(_vm.order.studio_instructions),callback:function ($$v) {_vm.$set(_vm.order, "studio_instructions", $$v)},expression:"order.studio_instructions"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.order.studio_instructions)?_c('small',{staticClass:"d-inline-flex"},[_vm._v("Please give 'The Studio' any guidance you can on what you would like to include in the design, the message you would like to deliver and what style of card you require.")]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),(_vm.order.design)?_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"d-flex align-items-end justify-content-between"},[_c('h6',[_vm._v("Chosen Template")]),_vm._v(" "),_c('b-btn',{staticClass:"text-danger py-0 mb-1",attrs:{"variant":"link"},on:{"click":function($event){_vm.order.design = ''}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('b-img',{attrs:{"src":_vm.order.design,"fluid":"","alt":"Selected Design"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-block col-lg-1 my-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-lg-5"},[_c('table',{staticClass:"table table-stripe-all table-bordered text-center text-uppercase"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle font-size-sm"},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("currency")(_vm.price)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-middle font-size-sm"},[_vm._v("VAT")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("currency")(_vm.vat)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-middle font-size-sm"},[_vm._v("Grand Total")]),_vm._v(" "),_c('td',{staticClass:"align-middle h3 font-weight-bold text-info"},[_vm._v(_vm._s(_vm._f("currency")(_vm.price + _vm.vat)))])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"ref-name"}},[_vm._v("Your name for job reference:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.ref_name),expression:"order.ref_name"}],staticClass:"form-control text-capitalize",attrs:{"type":"text","id":"ref-name","placeholder":"Enter Here"},domProps:{"value":(_vm.order.ref_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "ref_name", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('b-form-checkbox',{staticClass:"mt-2 mr-0 text-info",model:{value:(_vm.terms),callback:function ($$v) {_vm.terms=$$v},expression:"terms"}},[_c('span',{staticClass:"font-size-sm"},[_vm._v("I accept the ")])]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.terms",modifiers:{"terms":true}}],staticClass:"font-size-sm text-info"},[_c('u',[_vm._v("Terms & Conditions")])]),_vm._v(" "),_c('b-modal',{ref:"terms",attrs:{"id":"terms","size":"lg","hide-header":"","hide-footer":""}},[_c('terms',{staticClass:"my-5",attrs:{"termType":"terms"}}),_vm._v(" "),_c('button',{ref:"modalClose",staticClass:"btn modal-close",attrs:{"type":"button"},on:{"click":function($event){_vm.closeModal('terms')}}},[_c('i',{staticClass:"fa fa-times fa-lg",attrs:{"aria-hidden":"true"}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group text-right"},[_c('button',{staticClass:"btn btn-warning btn-lg",attrs:{"type":"submit","disabled":!_vm.canConfirm || _vm.loading || _vm.sending},on:{"click":_vm.confirm}},[(_vm.sending)?_c('span',[_vm._v("Submitting\n                        "),_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-fw"})]):_c('span',[_vm._v("Confirm Order")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mb-3"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.error.show},on:{"dismissed":function($event){_vm.error = { show: false, message: '' }}}},[_vm._v("\n                        "+_vm._s(_vm.error.message)+"\n                    ")])],1)])])])]):_c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"mt-5"},[_c('h3',[_vm._v("Thank you for your order")]),_vm._v(" "),_c('div',{staticClass:"m-4 d-flex flex-wrap justify-content-center"},_vm._l((_vm.order.basket.items),function(item){return _c('div',{key:item.id,staticClass:"d-flex flex-column m-3 p-3 border border-info rounded font-size-sm"},[_c('strong',[_vm._v(_vm._s(item.quantity)+" "+_vm._s(item.specification.documentSize)+" "+_vm._s(item.product.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.specification.stockWeight)+"GSM, "+_vm._s(item.specification.orientation)+", "+_vm._s(item.specification.lamination)+" Laminated")])])})),_vm._v(" "),_c('p',[_c('small',[_vm._v("Order reference number:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.order.ref))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Contact:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.order.ref_name))])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning btn-lg my-4",attrs:{"to":{name:'Dashboard'}}},[_vm._v("Return to Dashboard")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v("Your Order")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-inverse text-center"},[_c('tr',[_c('th',[_vm._v("Product Description")]),_vm._v(" "),_c('th',[_vm._v("Artwork / Assets")]),_vm._v(" "),_c('th',[_vm._v("Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-inline-flex"},[_c('small',[_vm._v("If you would like us to check availability for Royal Mail distribution, please tell us the postcode sectors (e.g. CB5 8__ ) and dates you would like. Or email us "),_c('a',{attrs:{"href":"mailto:royalmail@guildproperty.co.uk"}},[_vm._v("royalmail@guildproperty.co.uk")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Your order has been placed with 'The Studio'. A member of our design team will be in touch shortly to discuss the design of the card.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Once created the design will be sent to you for your approval before being sent to print.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "faPJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/we_heart_design_print.724f59d.png";

/***/ }),

/***/ "hFNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "inCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"d-flex align-items-center justify-content-md-end navatar"},[_c('img',{staticClass:"img-fluid mr-2 mr-lg-3",staticStyle:{"max-width":"5rem"},attrs:{"src":__webpack_require__("5nkz")}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"m-0 p-0"},[_vm._v("Talk to a Print Expert")]),_vm._v(" "),_c('h3',{staticClass:"m-0 my-1 p-0 agentColourOne"},[_vm._v(_vm._s(_vm.system.phone))]),_vm._v(" "),_c('p',{staticClass:"m-0 p-0"},[_vm._v("Available 8am - 6pm Monday to Friday")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('transition',{attrs:{"name":"bye"}},[(!_vm.sent)?_c('form',{staticClass:"my-5",on:{"submit":function($event){$event.preventDefault();return _vm.send($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"","required":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"email","placeholder":"","required":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"tel","id":"phone","placeholder":"","required":""}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col form-group"},[_c('label',{attrs:{"for":"message"}},[_vm._v("Your Message")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"type":"text","id":"message","placeholder":"","required":"","rows":"8"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col d-flex justify-content-end"},[_c('button',{staticClass:"btn btn-yellow",attrs:{"disabled":_vm.sending,"type":"submit"}},[_vm._v("\n                    "+_vm._s(_vm.sending ? 'Sending' : 'Send')+"\n                    "),(_vm.sending)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-fw",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-paper-plane-o fa-fw",attrs:{"aria-hidden":"true"}})])])])]):_c('div',{staticClass:"my-5 d-flex flex-column align-items-center justify-content-center"},[_c('h1',{staticClass:"mt-3"},[_vm._v("Thanks for getting in touch!")]),_vm._v(" "),_c('h2',{staticClass:"mt-3"},[_vm._v("We'll get back to you shortly")]),_vm._v(" "),_c('router-link',{staticClass:"my-5 btn btn-outline-info btn-lg",attrs:{"to":"/"}},[_vm._v("Back to the Dashboard")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 text-center text-md-left mb-3 mb-md-0"},[_c('h1',[_vm._v("Contact Us")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jfHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'customer-finder',
    methods: {
        refresh: function refresh() {
            this.$refs.finder.src = this.$refs.finder.src;
        },
        close: function close() {
            this.$root.$emit('bv::hide::modal', 'customerFinder');
            // this.$refs.modalClose.blur()
        }
    }
});

/***/ }),

/***/ "lN9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'artwork-requirements'
});

/***/ }),

/***/ "lPBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"my-5 container"},[_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-7 mb-4"},[_c('small',[_c('router-link',{staticClass:"text-dark",attrs:{"to":{name:'Products'}}},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}}),_vm._v("\n                    Back to selection\n                ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5 text-right"},[_c('cannot-find-button')],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-2 mb-3"},[_c('div',{staticClass:"col"},[(this.product)?_c('h1',{staticClass:"text-info"},[_vm._v(_vm._s(this.product.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 mb-3 mb-md-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"carousel","data-ride":"carousel","data-interval":"false"}},[_c('div',{staticClass:"carousel-inner"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"carousel-item",class:{ 'active': index == 0 }},[_c('span',{staticClass:"d-flex align-items-center justify-content-center"},[_c('img',{key:image.image,attrs:{"src":image.image}})])])})),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 gutters-sm"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"col-6 col-md-2 thumb"},[_c('img',{key:image.image,staticClass:"img-fluid",class:{ active: index == _vm.carouselIndex },attrs:{"src":image.image},on:{"click":function($event){_vm.goToCarouselImage(index)}}})])})),_vm._v(" "),(_vm.chosenArtwork && _vm.artwork == 2)?_c('div',{staticClass:"row mt-3 chosen-design"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h6',{staticClass:"m-0 p-0"},[_vm._v("Chosen Template")]),_vm._v(" "),_c('b-btn',{staticClass:"text-danger m-0 p-0",attrs:{"variant":"link"},on:{"click":function($event){_vm.chosenArtwork = null}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('b-img',{attrs:{"src":_vm.chosenArtwork.image,"fluid":"","alt":"Selected Design"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-5 specification"},[_c('h5',[_vm._v("Product Options & Pricing")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"size-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Top tip: 99x210 is 1/3 A4, sometimes referred to as DL, and is very effective."),_c('br'),_vm._v("\n                        Other sizes:"),_c('br'),_vm._v("\n                        A6 : 148mm x 105m"),_c('br'),_vm._v("\n                        A5 : 210mm x 148mm"),_c('br'),_vm._v("\n                        A4 : 297mm x 210mm"),_c('br'),_vm._v("\n                        A3 : 420mm x 297mm"),_c('br'),_vm._v("\n                        A2 : 594mm x 420mm"),_c('br'),_vm._v("\n                        A1 : 841mm x 594mm"),_c('br')])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.specification.documentSize),expression:"specification.documentSize"}],staticClass:"form-control custom-select",attrs:{"disabled":_vm.availableSpecification.documentSize.length < 1},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.specification, "documentSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.fetchSpecificationOptions('extent')}]}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select a size")]),_vm._v(" "),_vm._l((_vm.availableSpecification.documentSize),function(value,index){return _c('option',{key:index},[_vm._v(_vm._s(value))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"extent-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Extent is counted in ‘sides’ rather than sheets of paper, for example a single sheet has an extent of 2 (sides), fold that in half and it becomes 4.\n                    ")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.specification.extent),expression:"specification.extent"}],staticClass:"form-control custom-select",attrs:{"disabled":_vm.availableSpecification.extent.length < 1},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.specification, "extent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.fetchSpecificationOptions('orientation')}]}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select an extent")]),_vm._v(" "),_vm._l((_vm.availableSpecification.extent),function(value,index){return _c('option',{key:index},[_vm._v(_vm._s(value))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"orientation-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Landscape is big on width, Portrait is big on height.\n                    ")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.specification.orientation),expression:"specification.orientation"}],staticClass:"form-control custom-select",attrs:{"disabled":_vm.availableSpecification.orientation.length < 1},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.specification, "orientation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.fetchSpecificationOptions('stockWeight')}]}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select an orientation")]),_vm._v(" "),_vm._l((_vm.availableSpecification.orientation),function(value,index){return _c('option',{key:index},[_vm._v(_vm._s(value))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"weight-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Card and paper weights are measured in ‘gsm’, e.g. 300gsm is the most popular weight for canvassing cards. As standard we use a ‘silk’ stock, with a sleek but not overly shiny finish.\n                    ")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.specification.stockWeight),expression:"specification.stockWeight"}],staticClass:"form-control custom-select",attrs:{"disabled":_vm.availableSpecification.stockWeight.length < 1},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.specification, "stockWeight", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.fetchSpecificationOptions('lamination')}]}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select a weight")]),_vm._v(" "),_vm._l((_vm.availableSpecification.stockWeight),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(_vm.product.alias == 'Brochure' ? '350 / ' + value : value))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"lamination-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Matt Lamination adds a luxurious matt look and feel to your work. Gloss Lamination will shimmer in natural light to help produce an attention grabbing piece.\n                    ")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.specification.lamination),expression:"specification.lamination"}],staticClass:"form-control custom-select",attrs:{"disabled":_vm.availableSpecification.lamination.length < 1},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.specification, "lamination", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select lamination")]),_vm._v(" "),_vm._l((_vm.availableSpecification.lamination),function(value,index){return _c('option',{key:index},[_vm._v(_vm._s(value))])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex align-items-end justify-content-between"},[_vm._m(7),_vm._v(" "),_c('inspiration-modal',{attrs:{"type":_vm.artwork == 2 ? 'choose-your-design' : 'inspiration',"selected":_vm.productId}})],1),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"artwork-ttip","placement":"top"}},[_c('div',{staticClass:"ttip text-left"},[_vm._v("\n                        Let our talented Studio team craft your artwork, use our digital hub to create it (for canvassing cards only), or provide your own artwork.\n                    ")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.artwork),expression:"artwork"}],staticClass:"form-control custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.artwork=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":0}},[_vm._v("I'll provide my own")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("\n                        Design it for me\n                        "),(!_vm.design.loading)?_c('span',[_vm._v("(additional "+_vm._s(_vm._f("currency")(_vm.design.price))+" added)")]):_c('span',[_vm._v("(additional cost added)")])]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("\n                        Inspire Me\n                        "),(!_vm.design.loading)?_c('span',[_vm._v("(additional "+_vm._s(_vm._f("currency")(_vm.design.price))+" added)")]):_c('span',[_vm._v("(additional cost added)")])])]),_vm._v(" "),(_vm.artwork == 0)?_c('small',{staticClass:"d-block mt-1"},[_vm._v("Upload your artwork at the basket or send it to us later. Don't forget to check the "),_c('span',{staticClass:"text-info",attrs:{"id":"artwork-requirements-ttip"}},[_vm._v("requirements")])]):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"artwork-requirements-ttip","placement":"top"}},[_c('div',{staticClass:"ttip"},[_vm._v("\n                        Artwork must be a print-ready high resolution PDF, at 300dpi, with all images converted to CMYK and with 3mm bleed and crop marks.\n                    ")])]),_vm._v(" "),(_vm.artwork == 2 && !_vm.chosenArtwork)?_c('small',[_vm._v("Please select a template")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex align-items-end justify-content-between"},[_c('label',[_vm._v("Quantity")]),_vm._v(" "),_c('customer-finder')],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.quantity),expression:"quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"5000"},domProps:{"value":(_vm.quantity)},on:{"change":_vm.resetInvalidQuantity,"input":function($event){if($event.target.composing){ return; }_vm.quantity=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"price d-flex align-items-center"},[_c('strong',{staticClass:"text-info mr-2"},[_vm._v(_vm._s(_vm._f("currency")(_vm.finalPrice)))]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),(_vm.order)?_c('button',{staticClass:"btn btn-warning",attrs:{"type":"submit","disabled":!_vm.canOrder},on:{"click":_vm.updateOrder}},[_c('strong',[_vm._v("Save")]),_vm._v(" Order\n                ")]):_c('div',{attrs:{"id":"add-to-basket"}},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"submit","disabled":!_vm.canOrder},on:{"click":_vm.createOrder}},[_vm._v("\n                    Add to Basket\n                    ")])]),_vm._v(" "),(_vm.artwork == 2 && !_vm.chosenArtwork)?_c('b-tooltip',{attrs:{"target":"add-to-basket","placement":"top","triggers":"click hover focus"}},[_c('div',{staticClass:"ttip"},[_vm._v("\n                        Please select a template\n                    ")])]):_vm._e()],1),_vm._v(" "),(_vm.invalidQuantity)?_c('strong',{staticClass:"order-error text-danger mt-1"},[_vm._v("Your chosen quantity was not available."),_c('br'),_vm._v("Please see the table below for more options")]):_vm._e(),_vm._v(" "),(_vm.orderError)?_c('strong',{staticClass:"order-error text-danger mt-1"},[_vm._v(_vm._s(_vm.orderError))]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"mt-5"}),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('table',{staticClass:"table table-bordered text-center table-price"},[_vm._m(9),_vm._v(" "),_c('tbody',_vm._l((_vm.priceTable),function(entry,index){return (entry.price != 0)?_c('tr',{key:index},[_c('td',[_vm._v(_vm._s(entry.quantity))]),_vm._v(" "),(entry.loading)?_c('td',[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-fw"})]):_c('td',{staticClass:"price",on:{"click":function($event){_vm.order ? _vm.changeOrder(_vm.calculatedPrice(entry.price, entry.quantity), entry.quantity) : _vm.placeOrder(_vm.calculatedPrice(entry.price, entry.quantity), entry.quantity)}}},[_vm._v(_vm._s(_vm._f("currency")(_vm.calculatedPrice(entry.price, entry.quantity))))])]):_vm._e()}))])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"bg-secondary text-white p-3 rounded-top"},[_vm._v("\n                More Info\n            ")]),_vm._v(" "),(_vm.product)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.product.more_info)}}):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carousel","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carousel","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Size "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"size-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Extent "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"extent-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Orientation "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"orientation-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Weight (gsm) "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"weight-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Lamination "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"lamination-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Artwork "),_c('i',{staticClass:"fa fa-info-circle ml-1",attrs:{"id":"artwork-ttip","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('small',[_vm._v("inc. delivery to one UK address")]),_vm._v(" "),_c('small',[_vm._v("ex. VAT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Other prices based on your options")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lviy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting__ = __webpack_require__("W1GH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_accounting__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function () {
    for (var _len = arguments.length, para = Array(_len), _key = 0; _key < _len; _key++) {
        para[_key] = arguments[_key];
    }

    var value = para[0];
    var symbol = para[1] && para[1].hasOwnProperty('symbol') ? para[1].symbol : "£";
    var precision = para[1] && para[1].hasOwnProperty('precision') ? para[1].precision : 0;

    return __WEBPACK_IMPORTED_MODULE_1_accounting___default.a.formatMoney(value, symbol, precision);
});

/***/ }),

/***/ "mIQZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__ = __webpack_require__("abGE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bac92c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_products_html__ = __webpack_require__("nOq9");
function injectStyle (ssrContext) {
  __webpack_require__("OyDo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bac92c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bac92c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_products_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mp5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_vue__ = __webpack_require__("vhW+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b767db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_vue__ = __webpack_require__("JReE");
function injectStyle (ssrContext) {
  __webpack_require__("aoyh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14b767db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b767db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nAE/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nOq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-5 mt-3 mt-md-0"},[_c('cannot-find-button')],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row justify-content-md-center"},_vm._l((_vm.products),function(product){return _c('div',{staticClass:"col-lg-3 col-md-4 col-sm-6"},[_c('router-link',{staticClass:"card-link",attrs:{"to":{ name: 'Order', params: { productId: product.id }}}},[_c('div',{staticClass:"card pom-card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(product.name.split(' ')[0])+"\n                                "),_c('small',[_vm._v(_vm._s(product.name.split(product.name.split(' ')[0])[1]))])])]),_vm._v(" "),_c('div',{staticClass:"card-img-wrap embed-responsive embed-responsive-16by9"},[_c('img',{staticClass:"card-img-bottom",attrs:{"src":product.thumbnail,"alt":product.name}})])])])],1)}))]),_vm._v(" "),_c('div',{staticClass:"container-fluid bg-gradient-grey-white testimonials-wrapper"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"trust-pilot"},[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"small-12 carousel-wrapper"},_vm._l((_vm.reviews),function(review,index){return _c('div',{staticClass:"review-tile cell medium-3 plus",class:'order-' + review.order,attrs:{"data-order":review.order},on:{"click":_vm.moveCarousel}},[_c('div',{staticClass:"rating"},_vm._l((parseInt(review.rating)),function(n){return _c('i',{staticClass:"fa fa-star trustpilot-star-review",attrs:{"aria-hidden":"true"}})})),_vm._v(" "),_c('div',{staticClass:"review"},[_vm._v(_vm._s(review.review)+" - "+_vm._s(review.rating))]),_vm._v(" "),_c('div',{staticClass:"name"},[_c('strong',[_vm._v(_vm._s(review.name))])]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(review.date))]),_vm._v(" "),_c('div',{staticClass:"speech"})])}))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-7"},[_c('h1',[_vm._v("A world of choice...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-5 pb-4"},[_c('div',{staticClass:"col"},[_c('p',[_vm._v("Take advantage of your well established design and marketing studio, with a team of dedicated professionals\n                    offering over 50 years' experience. With our heritage and expertise, we understand what works.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Customer Satisfaction")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o7ng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_inspiration_js__ = __webpack_require__("NQ4m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437f365c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inspiration_vue__ = __webpack_require__("IkE1");
function injectStyle (ssrContext) {
  __webpack_require__("TEnN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-437f365c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_inspiration_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437f365c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inspiration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oA8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contact_js__ = __webpack_require__("WKCy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b668ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("inCE");
function injectStyle (ssrContext) {
  __webpack_require__("rF45")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25b668ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contact_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b668ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qr4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.customerFinder",modifiers:{"customerFinder":true}}],staticClass:"color-blue",attrs:{"size":"sm","variant":"link"}},[_vm._v("\n        Postcode Quantity Lookup\n        "),_c('i',{staticClass:"fa fa-search fa-lg",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-modal',{ref:"customerFinder",attrs:{"id":"customerFinder","size":"lg","hide-header":"","hide-footer":""},on:{"hidden":_vm.refresh}},[_c('div',{staticClass:"full"},[_c('iframe',{ref:"finder",attrs:{"src":"https://www.ukchanges.com/royalmail/door_to_door/find_customers.asp","frameborder":"0"}})]),_vm._v(" "),_c('button',{ref:"modalClose",staticClass:"btn modal-close",attrs:{"type":"button"},on:{"click":_vm.close}},[_c('i',{staticClass:"fa fa-times fa-lg",attrs:{"aria-hidden":"true"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rF45":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "si4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("9DWC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cace5bf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_login_html__ = __webpack_require__("P1x/");
function injectStyle (ssrContext) {
  __webpack_require__("WfPa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cace5bf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cace5bf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_login_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uCjX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uHln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outline-info btn-lg",attrs:{"to":"/"}},[_vm._v("Back to the Dashboard")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-2"},[_vm._v("404")]),_vm._v(" "),_c('h1',{staticClass:"display-3"},[_vm._v("Page not Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vhW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'terms',
    props: {
        termType: { type: String, required: true }
    },
    computed: {
        terms: function terms() {
            switch (this.termType) {
                case 'privacy-policy':
                    return this.$root.system.privacy_policy;
                case 'cookie-policy':
                    return this.$root.system.cookie_policy;
                default:
                    return this.$root.system.terms;
            }
        }
    }
});

/***/ }),

/***/ "vvwx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),

/***/ "y+/s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zxIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cannot_find_button_vue__ = __webpack_require__("7qkL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05541fb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cannot_find_button_vue__ = __webpack_require__("Wfi0");
function injectStyle (ssrContext) {
  __webpack_require__("uCjX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05541fb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cannot_find_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05541fb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cannot_find_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2be84595a768b8e49c3f.js